import React, { useEffect, useState } from "react";
import { Table } from "antd";
import SidebarHeaderLayout from "../../HOC/SidebarHeaderLayout";
import { useParams } from "react-router-dom";
import { getSinglePermission } from "../../../api-core/RolesPermissions";

const SinglePermission = () => {
  const { id } = useParams();
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false);
  useEffect(() => {
    const fetchSinglePermissions = async () => {
      setloading(true);
      const res = await getSinglePermission(id);
      setdata(res.permission);
      setloading(false);
    };
    fetchSinglePermissions();
  }, []);

  const datas = data.map((item) => ({
    key: item._id,
    permName: item.perm_name,
  }));

  const columns = [
    {
      title: "Sr",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      render: (id, record, index) => {
        ++index;
        return index;
      },
      showSorterTooltip: false,
    },
    {
      title: "Permission Name",
      dataIndex: "permName",
      key: "permName",
      ellipsis: true,
    },
  ];
  return (
    <div className="">
      <h1 className="text-center">List Of Permission</h1>
      <div className="">
        <Table
          dataSource={datas}
          columns={columns}
          loading={loading}
          // rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
        />
      </div>
    </div>
  );
};

export default SidebarHeaderLayout(SinglePermission);
